import postError from './postError';
const AJAX = {
  // 记录请求的 url
  reqUrl: '',
  // 记录请求的方法
  reqMethod: '',
  // 保存原生的 open 方法
  xhrOpen: window.XMLHttpRequest.prototype.open,
  // 保存原生的 send 方法
  xhrSend: window.XMLHttpRequest.prototype.send,
  init() {
    const that = this;

    window.XMLHttpRequest.prototype.open = function() {
      that.reqUrl = arguments[1];
      that.reqMethod = arguments[0];
      that.xhrOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function(data) {
      this.addEventListener('readystatechange', function(e) {
        if (this.readyState === 4) {
          if (!this.status || this.status >= 400) {
            // 错误收集
            let url = this.responseURL;
            let status = this.status;
            let statusText = this.statusText;
            let responseText = this.responseText;
            postError({
              ajaxUrl: url,
              ajaxStatus: status,
              ajaxStatusText: statusText,
              ajaxResponseTest: responseText,
              ajaxData: data
            });
            console.error('请求报错了：', this.status, data, this.responseURL, this);
          }
        }
      });

      that.xhrSend.apply(this, arguments);
    };
  },
};

AJAX.init();
